<wr-base-dialog
  status="info"
  [header]="header()"
  [submitResponse]="onSubmit.bind(this)"
  [disableSubmit]="disableSubmit"
>
  @if (form) {
    <hau-form [formGroup]="form">
      <hau-form-field
        label="Name"
        [validation]="form.validation.name"
        cols="12"
      >
        <input
          nbInput
          fullWidth
          type="text"
          formControlName="name"
          placeholder="Scan Name"
        />
      </hau-form-field>
      @if (isPointCloud) {
        <hau-form-field
          label="Punkt-Wolken-Nr"
          [validation]="form.validation.pointCloudId"
          cols="12"
        >
          <input
            nbInput
            fullWidth
            type="text"
            formControlName="pointCloudId"
            placeholder="Punkt-Wolken-Nr"
          />
        </hau-form-field>
      }
      <hau-form-field
        label="Gebäudeteile"
        [validation]="form.validation.sections"
        cols="12"
      >
        <wr-building-section-multi-select
          [buildingId]="buildingId"
          formControlName="sections"
        ></wr-building-section-multi-select>
      </hau-form-field>
    </hau-form>
  }
</wr-base-dialog>
